import { useState } from 'react';
import styled from 'styled-components';
import { RIGHT_ALIGNED } from '../visitor-widget/constants/WidgetLocations';
import { useWidgetResizeContext } from '../contexts/WidgetResizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CornerHandle = styled.div.withConfig({
  displayName: "WidgetResizeHandle__CornerHandle"
})(["position:absolute;top:0;", " width:16px;height:16px;cursor:", ";touch-action:none;z-index:10;"], ({
  $widgetLocation
}) => $widgetLocation === RIGHT_ALIGNED ? 'left: 0;' : 'right: 0;', ({
  $widgetLocation
}) => $widgetLocation === RIGHT_ALIGNED ? 'nwse-resize' : 'nesw-resize');
const TopEdgeHandle = styled.div.withConfig({
  displayName: "WidgetResizeHandle__TopEdgeHandle"
})(["position:absolute;top:0;left:0;right:0;height:8px;cursor:ns-resize;touch-action:none;z-index:5;"]);
const SideEdgeHandle = styled.div.withConfig({
  displayName: "WidgetResizeHandle__SideEdgeHandle"
})(["position:absolute;top:0;bottom:0;", " width:8px;cursor:ew-resize;touch-action:none;z-index:5;"], ({
  $widgetLocation
}) => $widgetLocation === RIGHT_ALIGNED ? 'left: 0;' : 'right: 0;');
const HOVERED_HANDLE = {
  TOP: 'top',
  SIDE: 'side',
  CORNER: 'corner'
};
const baseBorderStyle = {
  position: 'absolute',
  background: 'rgb(100, 100, 100)',
  pointerEvents: 'none',
  zIndex: 20,
  transition: 'opacity 0.15s ease-in-out'
};
export default function WidgetResizeHandle() {
  const {
    isResizeEnabled,
    onResizeHandlePointerDown,
    onTopEdgePointerDown,
    onSideEdgePointerDown,
    widgetLocation
  } = useWidgetResizeContext();
  const [hoveredHandle, setHoveredHandle] = useState(null);
  if (!isResizeEnabled) return null;
  const isRightAligned = widgetLocation === RIGHT_ALIGNED;
  const showTop = hoveredHandle === HOVERED_HANDLE.TOP || hoveredHandle === HOVERED_HANDLE.CORNER;
  const showSide = hoveredHandle === HOVERED_HANDLE.SIDE || hoveredHandle === HOVERED_HANDLE.CORNER;
  const sideEdge = isRightAligned ? {
    left: 0
  } : {
    right: 0
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: Object.assign({}, baseBorderStyle, {
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        opacity: showTop ? 0.5 : 0
      }),
      "aria-hidden": "true",
      "data-test-id": "widget-resize-top-border"
    }), /*#__PURE__*/_jsx("div", {
      style: Object.assign({}, baseBorderStyle, {
        top: 0,
        bottom: 0
      }, sideEdge, {
        width: 3,
        opacity: showSide ? 0.5 : 0
      }),
      "aria-hidden": "true",
      "data-test-id": "widget-resize-side-border"
    }), /*#__PURE__*/_jsx(TopEdgeHandle, {
      onPointerDown: onTopEdgePointerDown,
      onMouseEnter: () => setHoveredHandle(HOVERED_HANDLE.TOP),
      onMouseLeave: () => setHoveredHandle(null),
      "aria-hidden": "true",
      "data-test-id": "widget-top-edge-handle"
    }), /*#__PURE__*/_jsx(SideEdgeHandle, {
      $widgetLocation: widgetLocation,
      onPointerDown: onSideEdgePointerDown,
      onMouseEnter: () => setHoveredHandle(HOVERED_HANDLE.SIDE),
      onMouseLeave: () => setHoveredHandle(null),
      "aria-hidden": "true",
      "data-test-id": "widget-side-edge-handle"
    }), /*#__PURE__*/_jsx(CornerHandle, {
      $widgetLocation: widgetLocation,
      onPointerDown: onResizeHandlePointerDown,
      onMouseEnter: () => setHoveredHandle(HOVERED_HANDLE.CORNER),
      onMouseLeave: () => setHoveredHandle(null),
      "aria-hidden": "true",
      "data-test-id": "widget-resize-handle"
    })]
  });
}
WidgetResizeHandle.displayName = 'WidgetResizeHandle';